export default "__VITE_ASSET__wSLmUoQ1__"